/**
 * The chip's display label, derived from the message that started the
 * search. Shared between the live conversation (useMahiConversation.js) and
 * the chat-history list (ChatHistory.jsx) so a restored row reads exactly
 * the way it would have the moment she first returned it.
 */
export default function deriveChipLabel(firstMessage) {
  const trimmed = (firstMessage || '').trim();
  if (!trimmed) return 'Your search';
  return trimmed.length > 32 ? `${trimmed.slice(0, 31)}…` : trimmed;
}
